import { Grid, TextField } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import styles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import workflowStyles from "../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss"
import globalStyles from "../../../../assets/styles/global.module.scss";
import whatsappIcon from './../../../../assets/Whatsapp.svg'
import instagramIcon from './../../../../assets/images/channels/instagram/instagram.png'
import facebookIcon from './../../../../assets/facebook-logo.svg'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext'
import EditIcon from '@mui/icons-material/Edit';
import { isCurrentViewVersionPublished } from '../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import { handleHeaderDesignOfLeftSection, handleLeftPanel } from '../flowBuilderConstants';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { CHATBOT_CHANNEL_NAME } from '../../../../pages/ruleBasedInbox/channelConstants';

const WorkflowFormHeader = (props: any) => {
    
    const { headingName } = props
    
    const { nodes, setNodes, currentActiveNodeConfig, updateNodeCoordinates, setCurrentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload 
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;

    const [flagEditName, setFlagEditName] = useState<boolean>(false);
    const [stepName, setStepName] = useState<string>(nodes.find((node: any) => node.id == currentActiveNodeConfig.nodeId)?.chatbot_step_name);

    useEffect(() => {
        if (currentActiveNodeConfig) {
            setStepName(nodes.find((node: any) => node.id == currentActiveNodeConfig.nodeId)?.chatbot_step_name);
        }
    }, [currentActiveNodeConfig])

    const handleHeaderIcon = (mediaName: string) => {
        const mediaNameLower = mediaName.toLowerCase();

        switch (mediaNameLower) {
            case CHATBOT_CHANNEL_NAME.WHATSAPP?.toLowerCase():
                return <img alt="" src={whatsappIcon} className={styles.headerChannelIcon} />
            case CHATBOT_CHANNEL_NAME.INSTAGRAM?.toLowerCase():
                return <img alt="" src={instagramIcon} className={styles.headerChannelIcon} />
            case CHATBOT_CHANNEL_NAME.FACEBOOK?.toLowerCase():
                return <img alt="" src={facebookIcon} className={styles.headerChannelIcon} />
            default:
                return <img alt="" src={whatsappIcon} className={styles.headerChannelIcon} />
        }
    }

    const onBlurOfStepName = () => {
        setFlagEditName(false);
        const currentNode = nodes.find((node: any) => node.id == currentActiveNodeConfig.nodeId);
        if (currentNode.chatbot_step_name.trim().length > 0) {
            if (currentNode.chatbot_step_name != stepName) {
                updateNodeCoordinates(currentNode);
                setStepName(currentNode.chatbot_step_name);
            }
        } else {
            setNodes((nodes: any) => {
                return nodes.map((node: any) => {
                    if (node.id == currentActiveNodeConfig.nodeId) {
                        return {
                            ...node,
                            chatbot_step_name: stepName,
                        }
                    }
                    return node;
                })
            })
        }
    }

    const channelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name || "";

    return (
        <Grid item className={styles.headerFormItemStyle} sx={{ backgroundColor: handleHeaderDesignOfLeftSection(channelName.toLowerCase()), position: "relative" }}> 
            {currentActiveNodeConfig.flagOpenConfigForm && 
                <Grid item className={`${globalStyles.clickable} ${workflowStyles.leftSectionArrowIconForOpenGrid}`} onClick={() => handleLeftPanel(setCurrentActiveNodeConfig)}>
                    <ArrowBackIosNewIcon className={workflowStyles.leftSectionArrowIconForOpen} sx={{ transform: currentActiveNodeConfig.flagOpenConfigForm ? "" : "rotate(180deg)", }} />
                </Grid>
            }
            <Grid container gap={1} justifyContent={"center"} alignItems={"center"} flexWrap={"nowrap"}>
                <Grid item>
                    {handleHeaderIcon(channelName.toLowerCase())}
                </Grid>
                <Grid item className={styles.headerFormTextStyle}>
                    {flagEditName ?
                        <>
                            <TextField
                                className={`${styles.stepNameTextfield} ${styles.headerFormTextStyle}`}
                                value={nodes.find((node: any) => node.id == currentActiveNodeConfig.nodeId)?.chatbot_step_name}
                                autoFocus
                                onBlur={() => onBlurOfStepName()}
                                onKeyDown={(e) => {
                                    if (e.key?.toLowerCase() == "enter") {
                                        e.preventDefault();
                                        onBlurOfStepName();
                                    }
                                }}
                                onChange={(e) => {
                                    setNodes((nodes: any) => {
                                        return nodes.map((node: any) => {
                                            if (node.id == currentActiveNodeConfig.nodeId) {
                                                return {
                                                    ...node,
                                                    chatbot_step_name: e.target.value,
                                                }
                                            }
                                            return node;
                                        })
                                    })
                                }}
                            />
                        </>
                        :
                        <>{nodes.find((node: any) => node.id == currentActiveNodeConfig.nodeId)?.chatbot_step_name || "Send Message"}</>
                    }
                </Grid>
                {(headingName.toLowerCase() == "send message" && !flagEditName && !isCurrentViewVersionPublished(currentActiveStaticWorkflow)) && // Only for nodeWrapper & not for trigger node.
                    <Grid item className={globalStyles.displayFlexStyle}>
                        <EditIcon
                            className={styles.stepEditIcon}
                            onClick={() => setFlagEditName(true)}
                        />
                    </Grid>
                }
            </Grid>
        </Grid>
    )
}

export default WorkflowFormHeader
